import React from "react";
import UserSummaryCard from "./UserSummaryCard";

const StepConfirm = ({
  selectedTargetUser,
  mergeReason,
  labs,
  recommendations,
  questionnaires,
  testKits
}) => (
  <div>
    <h5>Are you sure you want to merge these users?</h5>
    <div className="d-flex my-3">
      <strong>Reason:</strong>
      <p className="ms-2">{mergeReason}</p>
    </div>
    <div className="d-flex justify-content-start w-100">
      <UserSummaryCard
        user={selectedTargetUser}
        labs={labs}
        recommendations={recommendations}
        questionnaires={questionnaires}
        testKits={testKits}
        title="Target User (after merge)"
      />
    </div>
  </div>
);

export default StepConfirm;
